<template>
    <div>
        <b-btn variant="warning" class="font-weight-bold" block @click="modal = true">
            Email Receipt
        </b-btn>
        <c-modal
            centered
            :tag="false"
            title="Email Receipt"
            size="md"
            cancel-label="Cancel"
            confirm-label="Send Email"
            :progressing="progressing"
            centered
            @submit="send"
            v-model="modal">
            <template>
                <div>
                    <b-alert :show="errors.any()" variant="danger" class="px-4">
                        <ul class="m-0 px-1">
                            <li v-for="err in errors.all()" :key="err">{{err}}</li>
                        </ul>
                    </b-alert>
                    <p>
                        Please enter the Email adress to get a receipt copy.
                    </p>
                    <b-form-group class="mb-0">
                        <b-input-group prepend="Email Address">
                            <b-input
                                type="text"
                                v-validate="'required|email'"
                                v-model="email"
                                name="Email Address"/>
                                
                                
                            </b-input-group>
                            <div class="d-flex justify-content-center">

                                <b-form-checkbox
                                class="mt-3 "
                                v-model="emailSubs"
                                name="checkbox"
                                value="true"
                                unchecked-value="false"
                                
                                >
                                Receive restaurant news & promotions
                                </b-form-checkbox>
                            </div>
                    </b-form-group>
                </div>
            </template>
        </c-modal>
<!--        <b-modal>-->
<!--            <b-card no-body class="mb-0">-->
<!--                <b-card-header>-->
<!--                    <span>Email Receipt</span>-->
<!--                </b-card-header>-->
<!--                <b-card-body>-->
<!--                    <b-alert :show="errors.any()" variant="danger" class="px-4">-->
<!--                        <ul class="m-0 px-1">-->
<!--                            <li v-for="err in errors.all()" :key="err">{{err}}</li>-->
<!--                        </ul>-->
<!--                    </b-alert>-->
<!--                    <p>-->
<!--                        Please enter the Email adress to get a receipt copy.-->
<!--                    </p>-->
<!--                    <b-form-group class="mb-0">-->
<!--                        <b-input-group prepend="Email Address">-->
<!--                            <b-input-->
<!--                                type="text"-->
<!--                                v-validate="'required|email'"-->
<!--                                v-model="email"-->
<!--                                name="Email Address"/>-->
<!--                        </b-input-group>-->
<!--                    </b-form-group>-->
<!--                </b-card-body>-->
<!--                <b-card-footer>-->
<!--                    <div class="d-flex flex-row justify-content-between">-->
<!--                        <b-btn @click="send" :variant="progressing || !email || errors.any() ? 'secondary' : 'warning'" :disabled="progressing || !email || errors.any()">Send Email</b-btn>-->
<!--                        <b-btn variant="warning" @click="modal = false" :disabled="progressing">Cancel</b-btn>-->
<!--                    </div>-->
<!--                </b-card-footer>-->
<!--            </b-card>-->
<!--        </b-modal>-->
    </div>
</template>

<script>
    import CModal from "./Cmodal";
    export default {
        name: "SendEmail",
        components: {CModal},
        props: {
            value: {
                required: true
            }
        },
        data () {
            return {
                modal: false,
                progressing: false,
                email: null,
                emailSubs:"true"
            }
        },
        watch: {
            model(nw,old){
                if(nw!=old)
                    this.emailSubs = "true"

            }
        },
        methods: {
            send () {
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        let emailConsent = 0
                        if(this.emailSubs === "true")
                            emailConsent = 1
                        const model = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            OrderId: this.value.OrderID,
                            PhoneNumber: this.value.Phone,
                            CustomerEmail: this.email,
                            HasConsent: emailConsent
                        }
                        
                        this.progressing = true
                        return this.$api.getRestaurant.SendEmailReceipt(model).then(res => {
                            this.progressing = false
                            if (res.success) {
                                this.modal = false
                            } else {
                                this.$showError(res.message)
                            }
                        }).catch(() => {
                            this.progressing = false
                        })
                    }
                })
                
            }
        }
    }
</script>

<style scoped>

</style>
